import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import AOS from 'aos';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    AOS.init({ duration: 900, once: true, offset: 80 });
  }, [pathname]);

  return null;
};

export default ScrollToTop;
